var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM11.2822 5.59282C11.5751 5.29993 12.0499 5.29993 12.3428 5.59282C12.6357 5.88572 12.6357 6.36059 12.3428 6.65348L10.0607 8.93565L12.5515 11.4265C12.8444 11.7193 12.8444 12.1942 12.5515 12.4871C12.2586 12.78 11.7837 12.78 11.4908 12.4871L9 9.99631L6.5092 12.4871C6.2163 12.78 5.74143 12.78 5.44854 12.4871C5.15564 12.1942 5.15564 11.7193 5.44854 11.4265L7.93934 8.93565L5.65717 6.65348C5.36428 6.36059 5.36428 5.88572 5.65717 5.59282C5.95007 5.29993 6.42494 5.29993 6.71783 5.59282L9 7.87499L11.2822 5.59282Z",
    fill: "#DE0909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/NO.948cb985712ff4c0c4cf5e83641a8f84.svg";
export { ForwardRef as ReactComponent };